import { Box, Link } from "@mui/material";
import { useContext } from "react";
import { ROUTE } from "../Interface/interface";
import { Context } from "../App";
import DataOption from "./dataOption";

const DataSettings = ({ handleFileUpload, setErrorMessage, inputError }: any) => {
  const { urlType, inputcode, setUrlType } = useContext(Context);

  return (
    <>
      <Box className="json-setting-wrap" display="flex" justifyContent="flex-end" alignItems="center" flexWrap="wrap">
        {urlType === ROUTE.JSON_PARSER || urlType === ROUTE.JSON_FORMATOR ? (
          <>
            <Link
              href={`${inputcode === "" ? `/${ROUTE.JSON_PARSER}` : "#"}`}
              className={`link-btn ${urlType === ROUTE.JSON_PARSER ? "active" : ""}`}
              target={inputcode === "" ? "_blank" : ""}
              rel="noreferrer"
              onClick={(e) => {
                if (inputcode !== "") setUrlType(`${ROUTE.JSON_PARSER}`);
              }}
            >
              JSON Parser
            </Link>
            <Link
              href={`${inputcode === "" ? `/${ROUTE.JSON_FORMATOR}` : "#"}`}
              className={`link-btn ${urlType === ROUTE.JSON_FORMATOR ? "active" : ""}`}
              target={inputcode === "" ? "_blank" : ""}
              rel="noreferrer"
              onClick={(e) => {
                if (inputcode !== "") setUrlType(`${ROUTE.JSON_FORMATOR}`);
              }}
            >
              JSON Format
            </Link>
          </>
        ) : (
          ""
        )}
        <DataOption handleFileUpload={handleFileUpload} setErrorMessage={setErrorMessage} inputError={inputError} />
      </Box>
    </>
  );
};

export default DataSettings;
